import React from 'react';
import { twilioSessionApi } from '../../redux/Reducers/commonApis';
import toast from 'react-hot-toast';

export default function CallIcon({ orderId, workerId, subscriptionId, disabled = false }) {
  const [loading, setLoading] = React.useState(false);
  const createTwilioSessionFn = () => {
    setLoading(true);
    const payload = {
      order_id: orderId,
      worker_id: workerId,
      subscription_id: subscriptionId,
    };
    const response = twilioSessionApi(payload);
    response?.then((res) => {
      setLoading(false);
      if (res?.status === 200 || res?.status === 201 || res?.status === 204) {
        //res has { "customer_masked_number": "+16148267612",}
        const phoneNumber = res?.data?.customer_masked_number;
        if (phoneNumber) {
          window.open(`tel:${phoneNumber}`, '_self');
        }
      } else {
        toast.error(res?.message || 'Something went wrong');
      }
    });
  };
  return (
    <div
      className={'border-client-link w-9 rounded-md border p-1 ' + (disabled ? 'cursor-not-allowed opacity-50' : '')}
      onClick={() => createTwilioSessionFn()}
    >
      {loading ? (
        <svg className='h-6 w-6 animate-spin stroke-gray-500' viewBox='0 0 256 256'>
          <line x1='128' y1='32' x2='128' y2='64' strokeLinecap='round' strokeLinejoin='round' strokeWidth='24'></line>
          <line
            x1='195.9'
            y1='60.1'
            x2='173.3'
            y2='82.7'
            strokeLinecap='round'
            strokeLinejoin='round'
            strokeWidth='24'
          ></line>
          <line
            x1='224'
            y1='128'
            x2='192'
            y2='128'
            strokeLinecap='round'
            strokeLinejoin='round'
            strokeWidth='24'
          ></line>
          <line
            x1='195.9'
            y1='195.9'
            x2='173.3'
            y2='173.3'
            strokeLinecap='round'
            strokeLinejoin='round'
            strokeWidth='24'
          ></line>
          <line
            x1='128'
            y1='224'
            x2='128'
            y2='192'
            strokeLinecap='round'
            strokeLinejoin='round'
            strokeWidth='24'
          ></line>
          <line
            x1='60.1'
            y1='195.9'
            x2='82.7'
            y2='173.3'
            strokeLinecap='round'
            strokeLinejoin='round'
            strokeWidth='24'
          ></line>
          <line x1='32' y1='128' x2='64' y2='128' strokeLinecap='round' strokeLinejoin='round' strokeWidth='24'></line>
          <line
            x1='60.1'
            y1='60.1'
            x2='82.7'
            y2='82.7'
            strokeLinecap='round'
            strokeLinejoin='round'
            strokeWidth='24'
          ></line>
        </svg>
      ) : (
        <svg
          xmlns='http://www.w3.org/2000/svg'
          fill='none'
          width='24'
          height='24'
          viewBox='0 0 24 24'
          strokeWidth='1.5'
          stroke='currentColor'
        >
          <path
            strokeLinecap='round'
            strokeLinejoin='round'
            d='M20.25 3.75v4.5m0-4.5h-4.5m4.5 0-6 6m3 12c-8.284 0-15-6.716-15-15V4.5A2.25 2.25 0 0 1 4.5 2.25h1.372c.516 0 .966.351 1.091.852l1.106 4.423c.11.44-.054.902-.417 1.173l-1.293.97a1.062 1.062 0 0 0-.38 1.21 12.035 12.035 0 0 0 7.143 7.143c.441.162.928-.004 1.21-.38l.97-1.293a1.125 1.125 0 0 1 1.173-.417l4.423 1.106c.5.125.852.575.852 1.091V19.5a2.25 2.25 0 0 1-2.25 2.25h-2.25Z'
          />
        </svg>
      )}
    </div>
  );
}
